import { render, staticRenderFns } from "./si_clue.vue?vue&type=template&id=3d1e8580&scoped=true&"
import script from "./si_clue.vue?vue&type=script&lang=js&"
export * from "./si_clue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e8580",
  null
  
)

export default component.exports